import {
	ChangeDetectionStrategy,
	Component,
	computed,
	EventEmitter,
	Input,
	Output,
	signal,
	WritableSignal,
} from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { IChecklistOption, IChecklistTemplate } from '@app/domain/types';
@Component({
	selector: 'checklist-items',
	imports: [MatButtonModule, ReactiveFormsModule, FormsModule, NgxTolgeeModule],
	templateUrl: './checklist-items.component.html',
	styleUrls: ['./checklist-items.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChecklistItemsComponent {
	@Input() set checklistTemplate(template: IChecklistTemplate) {
		if (!template) {
			return;
		}
		this.checklistOptions.set(template.options);
	}
	@Output() checklistTemplateChange = new EventEmitter<string>();

	checklistOptions: WritableSignal<IChecklistOption[]> = signal([]);
	overallCount = computed(() => this.checklistOptions().length);

	updateOptionAnswer(answer: boolean, index: number): void {
		this.checklistOptions.update(currentOptions => {
			const options = [...currentOptions];
			const existingAnswer = options[index].answer;
			options[index].answer = existingAnswer === answer ? null : answer;
			// basically we shouldn't care about what answer is, if we change it we can reset both reason and comment
			options[index].reason = '';
			options[index].comment = '';
			return options;
		});
		this.emitChanges();
	}

	optionTextInputChanged(text: string, index: number, field: string): void {
		this.checklistOptions.update(currentOptions => {
			const options = [...currentOptions];
			options[index][field] = text;
			return options;
		});
		this.emitChanges();
	}

	emitChanges(): void {
		const checklistTemplate = {
			options: this.checklistOptions(),
			overallCount: this.overallCount(),
		};
		this.checklistTemplateChange.emit(JSON.stringify(checklistTemplate));
	}
}
